import * as React from 'react'
import { Box } from '@mui/material'
import { formatPercentage } from "@ui-seeker/utils"

import { ArrowBackground, NotAllowedBlock } from '@components'


export default function diffColumn(label) {
	return {
		name: 'diff', label: label,
		options: {
			filter: false,
			customBodyRowRenderLite: (value, { myPrice, diff }) => <Box sx={{ textAlign: 'center '}}>
				{!!value && !!myPrice && <ArrowBackground
					value={value}
					backgroundColor={value > 0 ? 'success.light' : 'error.light'}
				>
					{formatPercentage(value, { decimals: 2 })}
				</ArrowBackground>}

				{(!value && !myPrice || !diff) && <NotAllowedBlock />}
			</Box>  
		}
	}
}